import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import ActionButtons from '../home/ActionButtons';
import { fetchAdmins, clearAdminsErrors, deleteAdmin } from '../../actions';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import Alert from '../home/Alert';
import DialogModal from '../home/DialogModal';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  adminsList: PropTypes.object.isRequired,
  admins: PropTypes.object.isRequired,
  adminDelete: PropTypes.bool,
  delete: PropTypes.bool,
};

class ShowAdmins extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      alertOpen: false,
      alertMessage: '',
      delete: false,
      scopes: ['SuperAdmin', 'Admin', 'Operator', 'Fulfillment', 'Read Only'],
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.adminDelete && (this.state.delete || nextProps.admins.delete)) {
      const admins = nextProps.admins;
      admins.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: 'Admin deleted!',
        admins,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
    });
  }
  handleDelete() {
    this.setState({
      delete: true,
    });
    this.props.dispatch(deleteAdmin(this.state.deleteId));
    this.props.dispatch(fetchAdmins({ page: 1 }));
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearAdminsErrors());
    this.props.dispatch(fetchAdmins({ page: 1 }));
  }
  renderRowsTable() {
    return this.props.adminsList.results.map(item =>
      <TableRow key={item.id}>
        <TableRowColumn key={item.id}>{item.name}</TableRowColumn>
        <TableRowColumn key={item.id}>{item.email}</TableRowColumn>
        <TableRowColumn key={item.id}>{this.state.scopes[item.role]}</TableRowColumn>
        <TableRowColumn key={item.id}>{item.signupDate}</TableRowColumn>
        <TableRowColumn key={item.id}>
          <ActionButtons
            onEdit={`/admins/${item.id}`}
            onView={`/admins/view/${item.id}`}
            onDelete={() => this.handleOpen(item.id)}
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Administrator"
          dialogMessage="Do you really want to delete this administrator?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn>Email</TableHeaderColumn>
              <TableHeaderColumn>Role</TableHeaderColumn>
              <TableHeaderColumn>Sign Up Date</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowAdmins.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowAdmins.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    adminDelete: state.admins.adminDelete,
    error: state.admins.error,
    admins: state.admins,
    delete: state.delete,
  };
}

export default connect(mapStateToProps)(ShowAdmins);



// WEBPACK FOOTER //
// ./src/components/admins/ShowAdmins.js